<template>
  <div
    ref="WsStateDropdownCheckboxInputAvatar001"
    class="ws-state-dropdown-checkbox-input-avatar-wrap"
  >
    <p v-if="title" class="title">{{ $t(title) }}<span v-if="required">*</span></p>
    <label v-if="hasCheckBox" class="checkbox-item">
      <input :value="isCheckBoxSelect" type="checkbox" @input="$_checkBoxSelect($event)" />
      <i class="icon-check-box-outline-blank" />
      <i class="icon-check-box" />
      <p>{{ checkboxText }}</p>
    </label>
    <ValidationProvider v-slot="{ errors }" :rules="rules" class="dropdown-wrap">
      <div
        v-click-outside="$_dropdownClose"
        class="ws-state-dropdown-checkbox-input-avatar-button"
        :class="{
          outline: outline,
          narrow: narrow,
          wide: wide,
          error: errors.length > 0,
          selected: value.length > 0,
          disabled: disabled,
        }"
      >
        <input type="hidden" :value="value" />
        <i v-if="leadingIcon" class="icon leading-icon" :class="leadingIcon" />
        <div class="input-button" @click="$_onclick()">
          <i
            v-if="outline"
            class="icon trailing-icon outline icon-chevron-up"
            :class="{ show: dropdown_menu_show }"
          />
          <i
            v-else-if="!outline && !dropdown_menu_show"
            class="icon trailing-icon icon-arrow-drop-down-circle"
          />
          <i
            v-else-if="!outline && dropdown_menu_show"
            class="icon trailing-icon icon-arrow-drop-up-circle"
          />
          <p class="input-button_text">
            {{ _selectName }}
          </p>
          <i v-if="_isDisplayCancelIcon" class="cancel-icon icon-cancel" @click.stop="$_onCancel" />
        </div>
        <div
          v-if="dropdown_menu_show"
          class="dropdown-menu"
          :class="{
            show: dropdown_menu_show,
            priority: priority,
            'drop-up': isDropUp,
          }"
        >
          <div class="search-tool">
            <SearchInput
              v-model="searchInputButton.value"
              :placeholder="searchInputButton.placeholder"
              :text-label="searchInputButton.textLabel"
              @enter="$_searchDropdown()"
            />
          </div>
          <perfect-scrollbar
            v-scroll:throttle="{ fn: $_onScroll, throttle: 32 }"
            class="ps dropdown-scrollable-content"
          >
            <DotLoading v-if="isLoading.list && !_dropdownItems.length" />
            <div v-if="_dropdownItems.length">
              <div
                v-for="(item, item_k) in _dropdownItems"
                :key="item_k"
                class="dropdown-menu-item"
              >
                <label>
                  <input
                    v-model="_checkedValue"
                    type="checkbox"
                    :value="item.id"
                    @change="$_checkboxOnchange(item)"
                  />
                  <div
                    v-if="type === 'custom'"
                    class="checkbox-icon"
                    :class="{ custom: type === 'custom' }"
                  >
                    <i class="checked icon-check-box" />
                    <i class="unchecked icon-check-box-outline-blank" />
                  </div>
                  <div
                    v-if="showAvatar"
                    class="avatar"
                    :style="{
                      backgroundImage: 'url(' + require('@/assets/image/avatar.svg') + ')',
                    }"
                  />
                  <LvText h6 noWrap class="ml-8">{{ $_dropdownItemText(item) }}</LvText>
                  <div v-if="type !== 'custom'" class="checkbox-icon">
                    <i class="checked icon-check-box" />
                    <i class="unchecked icon-check-box-outline-blank" />
                  </div>
                </label>
              </div>
            </div>
            <DotLoading v-if="isLoading.list && _dropdownItems.length" />
            <LvText v-if="!isLoading.list && !_dropdownItems.length" h6 noWrap class="ml-20">{{
              $t(emptyText)
            }}</LvText>
          </perfect-scrollbar>
          <div v-if="priority" class="add-btn" @click="$_addMemberOpen()">
            <WsTextButton001 leading-icon="icon-add-circle" primary>
              {{ addTextLabel }}
            </WsTextButton001>
          </div>
          <div v-if="hasInputButton">
            <WsTextButton001 @click="$_toggleDropdownMenuShow()">
              {{ $t('取消') }}
            </WsTextButton001>
            <div class="submit-btns">
              <WsTextButton001 primary @click="$_btnSubmit()">
                {{ $t('套用') }}
              </WsTextButton001>
            </div>
          </div>
        </div>
        <div v-if="addMemberActive" class="dropdown-menu" :class="{ show: addMemberActive }">
          <div class="menu-title">
            <i class="icon-arrow-left" @click="$_addMemberClose()" />
            <p>{{ addTextLabel }}</p>
          </div>
          <div class="dropdown-content">
            <StateInputButton
              v-for="(fieldItem, fieldKey) in addFieldsType"
              :key="fieldKey"
              v-model="addFields[fieldKey]"
              :title="fieldItem.title"
              :placeholder="fieldItem.placeholder"
              required
              :rules="fieldItem.rules"
              :disabled="fieldItem.disabled"
            />
            <div class="btns">
              <div class="btn">
                <WsButton001 out-line narrow>
                  {{ $t('取消') }}
                </WsButton001>
              </div>
              <div class="btn">
                <WsButton001 @click="$_addSubmitClick()">
                  {{ $t('送出') }}
                </WsButton001>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="errors.length > 0" class="invalid-text">
        <i class="icon-warning invalid-icon" />
        <p v-for="(text_e, text_k) in errors" :key="text_k" class="text">
          {{ $t(text_e) }}
        </p>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { ValidationProvider } from 'vee-validate';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import H_user from '@/helpers/user';
import H_dropdown from '@/helpers/dropdown';

extend('required', {
  ...required,
  message: '此項目為必填',
});
export default {
  name: 'WsStateDropdownCheckboxInputAvatar001',
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
  },
  props: {
    leadingIcon: {
      type: String,
      default: '',
    },
    outline: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    priority: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    selectValue: {
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    addTextLabel: {
      type: String,
      default: '',
    },
    customParams: {
      type: Object,
    },
    customUrl: {
      type: String,
      default: '',
    },
    customFields: {
      type: Object,
      default() {
        return {};
      },
    },
    customFieldsType: {
      type: Object,
      default() {
        return {};
      },
    },
    showAvatar: {
      type: Boolean,
      default: false,
    },
    hasInputButton: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasCheckBox: {
      type: Boolean,
      default: false,
    },
    checkboxText: {
      type: String,
      default: '',
    },
    isCheckBoxSelect: {
      type: Boolean,
      default: false,
    },
    scroll: {
      type: Number,
      default: 0,
    },
    emptyText: {
      type: String,
    },
    showCancelIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: {
        list: true,
      },
      dropdown_menu_show: false,
      searchInputButton: {
        value: '',
        placeholder: this.$t('搜尋'),
        textLabel: this.$t('搜尋'),
      },
      addMemberActive: false,
      addName: '',
      addEmail: '',
      position: { scrollTop: 0, scrollLeft: 0 },
      scrollTotalHeight: 0,
      windowTotalHeight: 0,
      currentPage: 1,
      lastPage: 1,
      dropdownMenuItem: [],
      contrastDropdownMenuItem: [],
      addFields: {},
      addFieldsType: {},
      memberFields: {
        name: '',
        email: '',
      },
      memberFieldsType: {
        name: {
          title: this.$t('人員名稱'),
          placeholder: this.$t('輸入'),
          rules: 'required',
        },
        email: {
          title: this.$t('信箱'),
          placeholder: this.$t('請輸入電子信箱'),
          rules: 'required|email',
        },
      },
      isDropUp: false,
      dropdownHeight: 0,
      dropdownTop: 0,
      windowHeight: 0,
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    _checkedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.checked_proxy = val;
      },
    },
    _selectName() {
      const placeholder = this.$t(this.placeholder);
      if (!this.contrastDropdownMenuItem.length) {
        return this.selectValue.length
          ? this.selectValue.map(value => value.name).join(', ')
          : placeholder;
      } else {
        if (this.value.length === 0) {
          return placeholder;
        } else {
          const selectItemList = this.contrastDropdownMenuItem.filter(item =>
            this.value.includes(item.id),
          );
          if (!selectItemList.length) {
            return this.selectValue.length
              ? this.selectValue.map(value => value.name).join(', ')
              : placeholder;
          } else if (this.value.length === selectItemList.length) {
            return selectItemList.map(value => value.name).join(', ');
          } else {
            if (this.selectValue.length === this.value.length) {
              return this.selectValue.map(value => value.name).join(', ');
            } else {
              this.selectValue.forEach(value => {
                const tarIndex = selectItemList.findIndex(item => item.id === value.id);
                if (tarIndex < 0) selectItemList.push(value);
              });
              return selectItemList.map(value => value.name).join(', ');
            }
          }
        }
      }
    },
    _remainNumber() {
      let selectNumber = this.value.length;
      let remainNumber;
      if (selectNumber > 3) {
        remainNumber = selectNumber - 3;
      } else {
        return;
      }
      return '+' + remainNumber;
    },
    _dropdownItems() {
      return this.dropdownMenuItem;
    },
    _isDisplayCancelIcon() {
      return this.showCancelIcon && this.value?.length > 0;
    },
  },
  watch: {
    scroll() {
      this.$_getDropdownHeight();
      this.$_isDropdownHide();
    },
    customParams() {
      this.contrastDropdownMenuItem = [];
      this.dropdownMenuItem = [];
    },
  },
  created() {
    window.addEventListener('resize', this.$_handleResize);
    window.addEventListener('resize', this.$_getDropdownHeight);
    window.addEventListener('resize', this.$_isDropdownHide);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_handleResize);
    window.removeEventListener('resize', this.$_getDropdownHeight);
    window.removeEventListener('resize', this.$_isDropdownHide);
  },
  mounted() {
    this.$_getAddField();
    this.$_getDropdownHeight();
    this.$_isDropdownHide();
  },
  methods: {
    $_getAddField() {
      this.addFields = this.memberFields;
      this.addFieldsType = this.memberFieldsType;
    },
    $_onScroll(e, position) {
      this.scrollTotalHeight = e.target.scrollHeight;
      this.windowTotalHeight = e.target.offsetHeight;
      this.position = position;
      this.$_scrollBottomGetDropdown();
    },
    $_onclick() {
      if (this.disabled) return;
      this.$_toggleDropdownMenuShow();
    },
    $_toggleDropdownMenuShow() {
      this.dropdown_menu_show = !this.dropdown_menu_show;
      if (this.dropdown_menu_show && !this.contrastDropdownMenuItem.length)
        this.$_getDropdownMenu();
    },
    $_dropdownClose() {
      this.dropdown_menu_show = false;
      this.addMemberActive = false;
      this.searchInputButton.value = '';
    },
    $_addMemberOpen() {
      this.addMemberActive = true;
      this.dropdown_menu_show = false;
    },
    $_addMemberClose() {
      this.addMemberActive = false;
      this.dropdown_menu_show = true;
    },
    $_checkBoxSelect($event) {
      this.$emit('checkbox-select', $event.target.checked);
    },
    $_checkboxOnchange(item) {
      this.$emit('input', this.checked_proxy);
      let selectInContrast = this.contrastDropdownMenuItem.find(
        menuItem => menuItem.id === item.id,
      );
      if (!selectInContrast) {
        this.contrastDropdownMenuItem.push(item);
      }
      const selectItems = [];
      this.checked_proxy.forEach(selectItemId => {
        const tartItem = this.contrastDropdownMenuItem.find(
          menuItem => menuItem.id === selectItemId,
        );
        if (tartItem) selectItems.push(tartItem);
      });
      this.$emit('update-select-value', selectItems);
    },
    $_btnSubmit() {
      this.$emit('btn-submit', this.checked_proxy);
    },
    $_searchDropdown() {
      this.$_getDropdownMenu('search');
    },
    $_searchMemberByName() {
      let originalItems = [...this.dropdownMenuItem];
      if (this.searchInputButton.value) {
        let searchOrigianlItems = originalItems.filter(item =>
          item.name.toLowerCase().includes(this.searchInputButton.value.toLowerCase()),
        );
        return searchOrigianlItems;
      }
      return originalItems;
    },
    async $_getDropdownMenu(type) {
      this.isLoading.list = true;
      try {
        if (type === 'search') {
          this.currentPage = 1;
        }
        let params = {
          page: this.currentPage,
          search: this.searchInputButton.value,
        };
        if (this.customParams) {
          params = {
            ...params,
            ...this.customParams,
          };
        }
        let getUrl = '';
        if (this.type === 'custom') {
          getUrl = this.customUrl;
        } else {
          getUrl = `/factory/${this._currentFactoryId}/simplify_factory_index`;
        }
        let res = await this.$axios.get(getUrl, {
          params: params,
        });
        let members =
          this.type === 'custom' ? res.data.data : H_user.setDropdownMenuList(res.data.data);
        this.lastPage = res.data.meta.last_page;
        if (type === 'search') {
          this.dropdownMenuItem = members;
        } else {
          this.dropdownMenuItem = this.dropdownMenuItem.concat(members);
          this.contrastDropdownMenuItem = this.dropdownMenuItem;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading.list = false;
      }
    },
    async $_addSubmitClick() {
      const isValidate = await this.$refs.memberObserver.validate();
      if (!isValidate) {
        return;
      }
      let getUrl = '';
      if (this.type === 'contractor') {
        getUrl = `/factory/${this._currentFactoryId}/contractor`;
      } else {
        getUrl = `/factory/${this._currentFactoryId}/user`;
      }
      try {
        const res = await this.$axios.post(getUrl, this.addFields);
        let addElementId = res.data.data.id;
        let dropdownItems =
          this.type === 'custom' ? [res.data.data] : H_user.setDropdownMenuList([res.data.data]);
        this.dropdownMenuItem = dropdownItems.concat(this.dropdownMenuItem);
        this.$emit('input', addElementId);
        this.$_dropdownClose();
      } catch (err) {
        alert(this.$t('新增發生錯誤'));
      }
    },
    $_scrollBottomGetDropdown() {
      const allScrollHeight = this.scrollTotalHeight - this.windowTotalHeight;
      const scrollHeight = this.position.scrollTop;
      if (scrollHeight / allScrollHeight > 0.9 && !this.articleLoading) {
        if (this.currentPage < this.lastPage) {
          this.currentPage += 1;
          this.$_getDropdownMenu();
        }
      }
    },
    $_dropdownItemText(item) {
      return H_dropdown.getListOfContractorOrAvatar(this.type, item);
    },
    $_handleResize() {
      this.windowHeight = window.innerHeight;
    },
    $_getDropdownHeight() {
      if (!this.$refs.WsStateDropdownCheckboxInputAvatar001) {
        return null;
      }
      let dropdownHeight = this.$refs.WsStateDropdownCheckboxInputAvatar001.getBoundingClientRect();
      this.dropdownHeight = dropdownHeight.height;
      this.dropdownTop = dropdownHeight.y;
    },
    $_isDropdownHide() {
      this.windowHeight = window.innerHeight;
      if (this.windowHeight - this.dropdownTop >= this.dropdownHeight + 400) {
        this.isDropUp = false;
      }
      if (this.windowHeight - this.dropdownTop < this.dropdownHeight + 400) {
        this.isDropUp = true;
      }
    },
    $_onCancel() {
      this.$emit('input', []);
      this.$emit('update-select-value', []);
    },
  },
};
</script>
